import React, {Component} from 'react';
import Select from "../common/virtualized-select";
import {List, Map} from "immutable";
import _ from 'lodash';

class EditAlertDialog extends Component {
    constructor(props) {
        super(props);

        const sendSchedule = this.props.alertType.get('send_schedule') || Map({});

        this.state = {
            status: this.props.alertType.get('status') || 'inactive',
            send_summary_email: this.props.alertType.get('send_summary_email') || false,
            send_schedule_interval: sendSchedule.get('interval') || 'day',
            send_schedule_day: sendSchedule.get('day') || 0,
            send_schedule_hour: sendSchedule.get('hour') || '0:00',
            email_list:  (this.props.alertType.get('email_list') || List([])).join(',\n')
        }
    }
    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    formatName = name => {
        switch (name) {
            case 'stock': return 'Alerta de Stock';
            case 'project_profit': return 'Alerta de rentabilidad de proyecto';
            case 'product_price': return 'Alerta de precio de productos';
            default: return 'Alerta de ' + name;
        }
    };

    validateAlertType = () => {
        if (
            ['active', 'inactive'].includes(this.state.status) &&
            _.isBoolean(this.state.send_summary_email) &&
            ['day', 'week'].includes(this.state.send_schedule_interval) &&
            _.isString(this.state.email_list)
        ) {
            this.props.onCanSubmit(true);
        } else {
            this.props.onCanSubmit(false);
        }
    };

    updateAlertType = () => {
        let send_schedule = Map({
            interval: this.state.send_schedule_interval
        });

        switch (this.state.send_schedule_interval) {
            case 'day':
                send_schedule = Map({
                    interval: this.state.send_schedule_interval,
                    hour: this.state.send_schedule_hour
                });
                break;
            case 'week':
                send_schedule = Map({
                    interval: this.state.send_schedule_interval,
                    day: this.state.send_schedule_day,
                    hour: this.state.send_schedule_hour
                });
                break;
            default:
                break;
        }

        this.props.updateAlertType(this.props.alertType.get('_id'), Map({
            status: this.state.status,
            send_summary_email: this.state.send_summary_email,
            send_schedule: send_schedule,
            email_list: _.map(_.split(this.state.email_list, ','), _.trim)
        }));
        this.props.onCloseModal();
    };

    render() {
        const statusOptions = [
            { desc: 'Sí', value: 'active' },
            { desc: 'No', value: 'inactive' }
        ];
        const sendMailOptions = [
            { desc: 'Sí', value: true },
            { desc: 'No', value: false }
        ];
        const intervalOptions = [
            { desc: 'Diariamente', value: 'day' },
            { desc: 'Semanalmente', value: 'week' }
        ];
        const dayOptions = [
            { desc: 'Lunes', value: 1 },
            { desc: 'Martes', value: 2 },
            { desc: 'Miercoles', value: 3 },
            { desc: 'Jueves', value: 4 },
            { desc: 'Viernes', value: 5 },
            { desc: 'Sabado', value: 6 },
            { desc: 'Domingo', value: 7 }
        ];
        let hourOptions = [];
        for (let i = 0; i <= 23; i++) {
            hourOptions.push({ hour: i + ':00' });
            hourOptions.push({ hour: i + ':30' });
        }

        // Send Schedule form
        let sendScheduleForm = (<div></div>);
        switch (this.state.send_schedule_interval) {
            case 'day':
                sendScheduleForm = (
                    <div className="row">
                        <div className="col">
                            <Select
                                className="virtualized-select"
                                options={intervalOptions}
                                value={this.state.send_schedule_interval}
                                labelKey="desc"
                                valueKey="value"
                                matchProp="desc"
                                multi={false}
                                searchable={false}
                                clearable={false}
                                onChange={ selected => this.setState({ send_schedule_interval: selected.value }, this.validateAlertType) }
                            />
                        </div>
                        <div className="col">
                            <Select
                                className="virtualized-select"
                                options={hourOptions}
                                value={this.state.send_schedule_hour}
                                labelKey="hour"
                                valueKey="hour"
                                matchProp="hour"
                                multi={false}
                                searchable={false}
                                clearable={false}
                                onChange={ selected => this.setState({ send_schedule_hour: selected.hour }, this.validateAlertType) }
                            />
                        </div>
                    </div>
                );
                break;
            case 'week':
                sendScheduleForm = (
                    <div className="row">
                        <div className="col">
                            <Select
                                className="virtualized-select"
                                options={intervalOptions}
                                value={this.state.send_schedule_interval}
                                labelKey="desc"
                                valueKey="value"
                                matchProp="desc"
                                multi={false}
                                searchable={false}
                                clearable={false}
                                onChange={ selected => this.setState({ send_schedule_interval: selected.value }, this.validateAlertType) }
                            />
                        </div>
                        <div className="col">
                            <Select
                                className="virtualized-select"
                                options={dayOptions}
                                value={this.state.send_schedule_day}
                                labelKey="desc"
                                valueKey="value"
                                matchProp="desc"
                                multi={false}
                                searchable={false}
                                clearable={false}
                                onChange={ selected => this.setState({ send_schedule_day: selected.value }, this.validateAlertType) }
                            />
                        </div>
                        <div className="col">
                            <Select
                                className="virtualized-select"
                                options={hourOptions}
                                value={this.state.send_schedule_hour}
                                labelKey="hour"
                                valueKey="hour"
                                matchProp="hour"
                                multi={false}
                                searchable={false}
                                clearable={false}
                                onChange={ selected => this.setState({ send_schedule_hour: selected.hour }, this.validateAlertType) }
                            />
                        </div>
                    </div>
                );
                break;
            default:
                break;
        }

        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Tipo de alerta</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.formatName(this.props.alertType.get('name'))}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>¿Alerta activa? *</label>
                        <Select
                            className="virtualized-select"
                            options={statusOptions}
                            value={this.state.status}
                            labelKey="desc"
                            valueKey="value"
                            matchProp="desc"
                            multi={false}
                            searchable={false}
                            clearable={false}
                            onChange={ selected => this.setState({ status: selected.value }, this.validateAlertType) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>¿Enviar resumen por correo?</label>
                        <Select
                            className="virtualized-select"
                            options={sendMailOptions}
                            value={this.state.send_summary_email}
                            labelKey="desc"
                            valueKey="value"
                            matchProp="desc"
                            multi={false}
                            searchable={false}
                            clearable={false}
                            onChange={ selected => this.setState({ send_summary_email: selected.value }, this.validateAlertType) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Periodicidad de envío</label>
                        { sendScheduleForm }
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Destinatarios (emails separados por comas)</label>
                        <textarea
                            className="form-control"
                            value={this.state.email_list}
                            onChange={ event => this.setState({ email_list: event.target.value }, this.validateAlertType) }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default EditAlertDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/EditAlertDialog.js